import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { TemplatesData } from '../lib/TemplatesData';

const ResumePreview = ({ templateId, getChildContentHeight = () => { }, isPreview = false }) => {
    const { id } = useParams();
    const contentRef = useRef();

    useEffect(() => {
        const element = contentRef.current;

        if (!element) return;

        const resizeObserver = new ResizeObserver((entries) => {
            getChildContentHeight(contentRef.current.offsetHeight); // Update the height state on change
        });

        resizeObserver.observe(element);

        // Cleanup the observer on component unmount
        return () => {
            resizeObserver.disconnect();
        };
    // eslint-disable-next-line
    }, [])
    templateId = id !== undefined ? id : templateId !== undefined ? templateId : localStorage.getItem("templateId")

    const SelectedTemplate = TemplatesData[templateId - 1]?.component

    return (

        <div ref={contentRef} >
            <SelectedTemplate isPreview={isPreview}/>
        </div>
    )
}

export default ResumePreview